import { createSelector } from 'reselect'
import { RootState } from '../types'
import { LoadingStateEnum } from '../../types'

export const getCommissionsLoadingState = (state: RootState): RootState['commissions']['loading'] =>
  state.commissions.loading

export const commissionsLoading = createSelector(
  getCommissionsLoadingState,
  (state): boolean => state === LoadingStateEnum.LOADING,
)

export const getCommissionsData = (state: RootState): RootState['commissions']['data'] => state.commissions.data
export const getCommissionsError = (state: RootState): RootState['commissions']['error'] => state.commissions.error

export const approveCommissionsModal = (state: RootState): RootState['commissions']['approveCommissionsModal'] =>
  state.commissions.approveCommissionsModal

export const adjustCommissionsModal = (state: RootState): RootState['commissions']['adjustCommissionsModal'] =>
  state.commissions.adjustCommissionsModal

export const adjustConfirmCommissionsModal = (
  state: RootState,
): RootState['commissions']['adjustConfirmCommissionsModal'] => state.commissions.adjustConfirmCommissionsModal

export const rejectCommissionsModal = (state: RootState): RootState['commissions']['rejectCommissionsModal'] =>
  state.commissions.rejectCommissionsModal
